import React from 'react';
import { Route, Routes } from 'react-router';
import { PagePath } from '../navigation.enums';
import { ActiveCompanySlugRedirect } from './routers.helpers';
import { FreemiumPeopleCMSPage } from '../../pages/freemium-feature/freemium-people/pages/freemium-people.cms.page';
import { FreemiumBulkUploadFocusPanel } from '../../pages/freemium-feature/freemium-people/panels/bulk-upload-focus-panel/freemium-bulk-upload-focus-panel';

export function FreemiumUserManagementRouter(): JSX.Element {
  return (
    <Routes>
      <Route path={PagePath.freemiumUserManagementPeople} element={<FreemiumPeopleCMSPage />} />
      <Route path={PagePath.freemiumUserManagementPeopleBulkUpload} element={<FreemiumBulkUploadFocusPanel
        onCancel={() => { console.log(); }}
      />} />
      <Route path={PagePath.rootWildcard} element={<ActiveCompanySlugRedirect landingRedirectTo={`${PagePath.freemiumUserManagementBase}${PagePath.freemiumUserManagementPeople}`} />} />
    </Routes>
  );
}
